import { isHotelProperty, isUltimate } from '@merchant-backend/util'
import { inject, observer } from 'mobx-react'
import React, { Component } from 'react'
import { CHANNEL } from '../constant'
import style from './style.module.less'

@inject('pageStore')
@observer
export default class extends Component {
  render() {
    const { SOURCE_TABLE_IMG } = this.props.pageStore.getPageConfig()
    const _isUltimate = isUltimate()
    const { forPro } = this.props
    return (
      <div className={style.center}>
        <div className={style.channel}>
          <h3 className={style.title}>获客拓展</h3>
          <p className={style.tip}>多渠道引流，提升品牌知名度</p>
          <ul className={style['channel-list']}>
            {CHANNEL(forPro).map((item, index) => {
              let link = item.link
              if (_isUltimate) {
                link = item.openLink
              }

              return (
                <li key={index}>
                  <a href={link}>
                    <img src={item.img} />
                    <p>{item.title}</p>
                  </a>
                </li>
              )
            })}
          </ul>
          {forPro &&
            isHotelProperty() && (
              <img
                src={'https://qnm.hunliji.com/FtgsqfMwTKFjcpxECBBT8qX7w7ig'}
              />
            )}
          {forPro &&
            isHotelProperty() && (
              <img
                src={'https://qnm.hunliji.com/Fo4CHgidNI527XNTu9TAzW80UtZd'}
              />
            )}
          {!isHotelProperty() && (
            <img src={SOURCE_TABLE_IMG} className={style['channel-img']} />
          )}
        </div>
      </div>
    )
  }
}
